import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import period from '../Assets/period.svg';
import linkedin from '../Assets/linkedin-hover.png';
import linkedinHover from '../Assets/linkedin.png';
import dribbble from '../Assets/dribbble-hover.png';
import behance from '../Assets/behance-hover.png';
import resume from '../Assets/Devanshi-Resume.pdf';

function Footer() {
  return (
    <Container fluid className="footer" id="footer" style={{width: '100%'}}>
      <Row>
        <Col sm="1" className="footer-copywright">

        </Col>

        <Col sm="7" className="footer-body" style={{paddingLeft:'8%'}}>
        <h1 className="git" style={{ fontFamily:'Changa',fontSize: '1.6em', color: 'white', verticalAlign: 'bottom', paddingTop: '16px', paddingBottom: '8px', alignItems:'start', alignContent:'start', fontWeight: '400'}}>LET'S GET IN TOUCH<img
                      src={period}
                      alt="period"
                      className="img-fluid period"
                      style={{ justifyItems: 'start', marginBottom: '1.5%', marginLeft:'0.1%',  verticalAlign: 'bottom' }}
                    />
        </h1>
        <p className="content" style={{color: 'white', textAlign:'left'}}><a className="links-footer links" rel="noopener noreferrer" target="_blank" href={resume}><b>View my <b> resume</b></b></a></p>
        <p className="content" style={{color: 'white', textAlign:'left'}}><a className="links-footer links" href="mailto: devanshijhaveri2001@gmail.com"><b>devanshijhaveri2001@gmail.com</b></a></p>
          

        </Col>
        <Col sm="3" className="footer-body right-footer" style={{verticalAlign:'bottom', paddingBottom: '16px'}}>
        
        <Row className="footer-logos" style={{paddingTop: '10px'}}>
        <Col  style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent: 'flex-end'}} className="box-col footer-box">
                    <a className="links" rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/in/devanshi-jhaveri-aa548b1a4/"><div className="contact-box box-head box-headf" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '60px', width: '60px' }}>
                    <p className="contact-box contact-head " style={{marginBottom: '0px'}}>
                      <img src={linkedin}
                      alt="period"
                      className="img-fluid footer-img"
                      style={{ height: '35px', width: '35px'}}
                    />
                      {/* <img src={linkedinHover}
                      alt="period"
                      className="img-fluid footer-hover"
                      style={{ height: '35px', width: '35px'}}
                    /> */}
                    </p>
                    </div></a>
                    {/* <text style={{fontSize: '16px'}}>LINKEDIN</text> */}
                    </Col>
                    <Col  style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent: 'flex-end'}} className="box-col footer-box">
                    <a className="links " rel="noopener noreferrer" target="_blank" href="https://www.behance.net/devanshijhaveri24"><div className="contact-box box-head box-headf" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '60px', width: '60px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}><img
                      src={behance}
                      alt="period"
                      className="img-fluid footer-img"
                      style={{height: '35px', width: '35px'}}
                    /></p>
                    </div></a>
                    {/* <text style={{fontSize: '16px'}}>BEHANCE</text> */}
                    </Col>
                    <Col style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent: 'flex-end'}} className="box-col footer-box">
                    <a className="links " rel="noopener noreferrer" target="_blank" href="https://dribbble.com/devanshijhaveri"><div className="contact-box box-head box-headf" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '60px', width: '60px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}><img
                      src={dribbble}
                      alt="period"
                      className="img-fluid footer-img"
                      style={{height: '35px', width: '35px'}}
                    /></p>
                    </div></a>
                    {/* <text style={{fontSize: '16px'}}>DRIBBBLE</text> */}
                    </Col>
                    {/* <Col sm={1}  className="box-col">
                    <a className="links " rel="noopener noreferrer" target="_blank" href={resume}><div className="contact-box box-head" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '100px', width: '250px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}>RESUME</p>
                    </div></a>
                    </Col> */}
        </Row>
        </Col>
      </Row>
      
    </Container>
  );
}

export default Footer;